/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiIncrementalityTestType;
(function (ApiIncrementalityTestType) {
    ApiIncrementalityTestType["INCREMENTALITY_TEST_TYPE_UNSPECIFIED"] = "IncrementalityTestTypeUnspecified";
    ApiIncrementalityTestType["INCREMENTALITY_TEST_TYPE_GEO_SWITCH_OFF"] = "IncrementalityTestTypeGeoSwitchOff";
    ApiIncrementalityTestType["INCREMENTALITY_TEST_TYPE_GEO_ROLLOUT"] = "IncrementalityTestTypeGeoRollout";
})(ApiIncrementalityTestType || (ApiIncrementalityTestType = {}));
export function ApiIncrementalityTestTypeFromJSON(json) {
    return ApiIncrementalityTestTypeFromJSONTyped(json, false);
}
export function ApiIncrementalityTestTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiIncrementalityTestTypeToJSON(value) {
    return value;
}
